import React from 'react';
import type { IconProps } from '../types';

export const OrientationSwitchS = (props: IconProps) => (
  <svg
    {...props}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.57766 17.4182L9.4655 19.8288L6.80457 21.4557"
      stroke="currentColor"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M19.5918 15C19.8503 15.1669 20.067 15.3909 20.2253 15.6547C20.3836 15.9186 20.4793 16.2152 20.5049 16.5218C20.5049 18.3123 16.991 19.7938 12.5153 19.946"
      stroke="currentColor"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.46782 19.828C5.73931 19.4354 3 18.1038 3 16.5218C3.02464 16.2179 3.11841 15.9236 3.27416 15.6614C3.4299 15.3992 3.6435 15.1761 3.89865 15.0091"
      stroke="currentColor"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.4308 15.1523C9.60266 15.1523 8.38391 14.3906 8.02844 13.3496C7.97131 13.1973 7.93958 13.0322 7.93958 12.8799C7.93958 12.4229 8.23157 12.1309 8.66321 12.1309C9.02502 12.1309 9.25354 12.2769 9.43127 12.645C9.71692 13.4385 10.504 13.7939 11.4816 13.7939C12.5861 13.7939 13.3605 13.248 13.3605 12.4863C13.3605 11.8262 12.9034 11.4199 11.7101 11.1724L10.7262 10.9692C8.89172 10.5947 8.03479 9.73145 8.03479 8.39209C8.03479 6.77979 9.45032 5.68799 11.4371 5.68799C13.0558 5.68799 14.3126 6.41162 14.6871 7.62402C14.7252 7.72559 14.7443 7.84619 14.7443 7.99854C14.7443 8.39844 14.4586 8.67139 14.0333 8.67139C13.6525 8.67139 13.4176 8.50635 13.2462 8.15088C12.9352 7.37646 12.2814 7.04639 11.4244 7.04639C10.4088 7.04639 9.68518 7.52881 9.68518 8.29688C9.68518 8.91895 10.1422 9.31885 11.2848 9.56006L12.2687 9.76318C14.1984 10.1631 15.0109 10.9375 15.0109 12.2959C15.0109 14.0479 13.6334 15.1523 11.4308 15.1523Z"
      fill="currentColor"
    />
  </svg>
);

export default OrientationSwitchS;
